import Vue from 'vue'
import Session from '../models/session'
import ApiBase from '@/api/apiBase'

class ApiLogin{
  static login(email, password, callBack, errorCallBack){
    let data = { email: email, password: password }
    ApiBase.post(`/login`, data, callBack, ApiLogin.parseLogin, errorCallBack)
  }
  static parseLogin(response){
    return Session.parse(response.data.data)
  }
}

export default ApiLogin



// WEBPACK FOOTER //
// ./src/api/apiLogin.js